import { ShipOrderLineItem } from '../../ShipOrderLineItem';
import { ValidShipOrderLineItem } from '../ValidShipOrderLineItem';

export class ShipOrderLineItemSplitBuilder {
  readonly shipOrderLineItem: ValidShipOrderLineItem;
  private _qtyToKeep: number = 0;
  private _qtyOnNew: number = 0;

  constructor(shipOrderLineItem: ShipOrderLineItem) {
    if (!ValidShipOrderLineItem.isValidShipOrderLineItem(shipOrderLineItem)) {
      throw new Error('Invalid ShipOrderLineItem');
    }

    this.shipOrderLineItem = shipOrderLineItem;
    this.qtyToKeep = shipOrderLineItem.quantity;
  }

  get qtyToKeep(): number {
    return this._qtyToKeep;
  }

  set qtyToKeep(qty: number) {
    if (qty < 0) {
      qty = 0;
    } else if (qty > this.shipOrderLineItem.quantity) {
      qty = this.shipOrderLineItem.quantity;
    }

    this._qtyToKeep = qty;
    this._qtyOnNew = this.shipOrderLineItem.quantity - qty;
  }

  get qtyOnNew(): number {
    return this._qtyOnNew;
  }

  set qtyOnNew(qty: number) {
    if (qty < 0) {
      qty = 0;
    } else if (qty > this.shipOrderLineItem.quantity) {
      qty = this.shipOrderLineItem.quantity;
    }

    this._qtyOnNew = qty;
    this._qtyToKeep = this.shipOrderLineItem.quantity - qty;
  }
}
